import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MODALS } from './constants';
import style from './style.scss';
import { closePopup } from './action';
import Subscribe from './Subscribe';
import Invest from './Invest';
import TrusteeDetail from './TrusteeDetail';
import AccountStatement from './AccountStatement';
import RemunerationLogin from './RemunerationLogin';
import ContinuedInvestor from "./ContinuedInvestor";
import BasicForm from "./BasicForm";
import BasicFormETF from "./BasicFormETF";
import VerifyOtp from "./VerifyOtp";
import ForceLogout from "./ForceLogout";
import SuccesssModal from "./SuccesssModal";
// ecart start
import ECartModal from "./ECartModal";
import Authentication from './Authentication';
import VerifyOtpEcart from './VerifyOtpEcart';
import ReplaceItems from './ReplaceItems';
import { cleanAuthContent } from "./Authentication/action";
import ErrorModalEcart from "./ErrorModalEcart";
import EkycValidateModal from "./ekycValidateModal";
import { ToastContainer } from 'react-toastify';
import cookie from "react-cookies";
// ecart end

class Modal extends Component {
    constructor(props) {
        super(props);
        // this.state = {
        //     popupData: false, 
        // }; 
        this.modalRef = React.createRef();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        // this.handlepopupshow = this.handlepopupshow.bind(this);
        // this.handlepopupClose = this.handlepopupClose.bind(this);
        }
    componentWillMount() {
        if (this.props.modal.showModal === true) {
            document.body.style.overflow = 'hidden';
            document.body.style['-ms-overflow-style'] = 'none';
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleOutsideClick)
        const closeModal = document.getElementById('close-focued');
        closeModal && document.getElementById('close-focued').focus() && closeModal.addEventListener('keydown', (e) => {
            if (e.keyCode == 13 || e.keyCode == 27) {
                this.props.closePopup();
            }
        });
    }

    componentWillUnmount() {
        document.body.style.overflowY = 'auto';
        document.body.style['-ms-overflow-style'] = 'auto'
    }
    // handlepopupshow = ()=>{
    //     this.setState({ popupData: true }); 
    // };
    // handlepopupClose = ()=>{
    //     this.setState({ popupData: false }); 
    // };
    handleOutsideClick(event) {
        if(this.modalRef.current && this.modalRef.current.contains(event.target) == false){
            const isToastClick = event.target.closest('.Toastify__toast-container');
            // const isInvestNow = cookie.load("isInvest") == "true" || false;
            if (!isToastClick) {
                // if(isInvestNow){
                //     this.handlepopupshow();
                // }
                // else{
                    this.props.closePopup();
                // }
            }
        }
    };
    
    showModalContent = () => {
        const { modal: { modalName, modalParameters }, closePopup } = this.props;

        if (modalName) {
            switch (modalName) {
                case MODALS.SUBCRIBE_PRODUCTS:
                    return (
                        <Subscribe {...modalParameters} />
                    );
                case MODALS.TRUSTEE_DETAIL:
                    return (
                        <TrusteeDetail {...modalParameters} />
                    )
                case MODALS.INVEST_OPTIONS:
                    return (
                        <Invest {...modalParameters} />
                    )
                case MODALS.ACCOUNT_STATEMENT:
                    return (
                        <AccountStatement {...modalParameters} />
                    )
                case MODALS.REMUNERATION_LOGIN:
                    return (
                        <RemunerationLogin {...modalParameters} />
                    )
                case MODALS.CONTINUED_INVESTOR:
                    return (
                        <ContinuedInvestor {...modalParameters} />
                    )
                case MODALS.BASIC_FORM:
                    return (
                        <BasicForm {...modalParameters} />
                    )
                case MODALS.BASIC_FORM_ETF:
                    return (
                        <BasicFormETF {...modalParameters} />
                    )
                case MODALS.VERIFY_OTP:
                    return (
                        <VerifyOtp {...modalParameters} />
                    )
                case MODALS.FORCE_LOGOUT:
                    return (
                        <ForceLogout {...modalParameters} />
                    )

                case MODALS.SUCCESSS_MODAL:
                    return (
                        <SuccesssModal {...modalParameters} />
                    )
                case MODALS.ECART_MODAL:
                    return <ECartModal
                        {...modalParameters}
                        // popupData = {this.state.popupData}
                        // handlepopupshow = {this.handlepopupshow}
                        // handlepopupClose = {this.handlepopupClose} 
                    />;
                case MODALS.AUTHENTICATION:
                    return <Authentication {...modalParameters} />;
                case MODALS.VERIFY_OTP_ECART:
                    return <VerifyOtpEcart {...modalParameters} />;
                case MODALS.REPLACE_ITEMS_ECART:
                    return <ReplaceItems {...modalParameters} />;
                case MODALS.ERROR_MODAL_ECART:
                    return <ErrorModalEcart {...modalParameters} />;
                case MODALS.EKYC_VALIDATE_MODAL:
                    return <EkycValidateModal {...modalParameters} />;
            }
        }
    };
    render = () => {
        const { modal: { modalName, showHeader, modalParameters }, closePopup, cleanAuthContent} = this.props;
        const content = this.showModalContent();
        return (
            <div className={modalParameters && modalParameters.modalClass ? modalParameters.modalClass : ''}>
                <div className={`popupOuter ${modalName === "ECART_MODAL" && "ecart-modal"}`} ref={this.modalRef}>

                    <div className={modalName === "ECART_MODAL"
                        ? "popupSec cart-modal" : showHeader ? 'popupSec align-center' : 'popupSec align-center success-modal'}>
                        {modalName == MODALS.WRITE_US ?
                            <div></div> : <div>
                                {showHeader && modalName != "CONTENT_DECLARATION" && <i id="close-focued" role="tab" tabIndex="0" className='icon-close cross'
                                    onClick={() => {
                                        if (modalName === 'REPLACE_ITEMS_ECART' || modalName === 'VERIFY_OTP_ECART') {
                                            cleanAuthContent();
                                        } 
                                        closePopup() }} />}
                                {showHeader && modalParameters && (modalParameters.heading || modalParameters.subHeading)
                                    && <div className='modal-header'>
                                        <h2>{modalParameters.heading}</h2>
                                        <p>{modalParameters.subHeading}</p>
                                    </div>}
                                {content}
                            </div>}
                    </div>

                </div>
                <div className='popup_overlay black_overlay' />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                    type="error"
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    modal: state.modal,
});

const mapDispatchToProps = (dispatch) => ({
    closePopup: bindActionCreators(closePopup, dispatch),
    cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch)
});
const ModalContainer = connect(mapStateToProps, mapDispatchToProps)(Modal);

export default ModalContainer;
